// extracted by mini-css-extract-plugin
export default {"label":"Canvas_label__tVNfY","inputContainer":"Canvas_inputContainer__V1vg+","secondaryButton":"Canvas_secondaryButton__zNAXw","buttonContainer":"Canvas_buttonContainer__-TJ0N"};